//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { go } from '../../libs/router'

export default {
  name: 'grid-item',
  props: ['icon', 'label', 'link'],
  created () {
    this.$parent.countColumn()
  },
  mounted () {
    this.$slots.icon && (this.hasIconSlot = true)
    this.$slots.label && (this.hasLabelSlot = true)
  },
  destroyed () {
    this.$parent.countColumn()
  },
  computed: {
    style () {
      const column = this.$parent.column
      if (!column || column === 3) {
        return
      }
      const styles = {}
      styles.width = `${100 / column}%`
      return styles
    }
  },
  methods: {
    onClick () {
      this.$emit('on-item-click')
      go(this.link, this.$router)
    }
  },
  data () {
    return {
      hasIconSlot: false,
      hasLabelSlot: false
    }
  }
}



// WEBPACK FOOTER //
// ./~/vux/src/components/grid/grid-item.vue